import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { ApplicationUser } from './ApplicationUser';

export class UserAccount extends ApplicationUser {
    _originalTypeClassName = "zSHR.BO.UserAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UserAccount.translate = translateService;
}
super();
this.BearerToken = null;
this.TokenExpirationTime = null;
this._key = this.UserName = ""; 
}

static translate: TranslateService;
_key: any;
BearerToken:any;
TokenExpirationTime:any;

static GetActive(): any{try {return Joove.Common.cast(window._context.currentUser, "Domain.UserAccount");}
catch (e) {return null;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserName == null || $this.UserName == "";
            }


}